module.exports = __webpack_public_path__ + "static/fonts/Fact-CompressedExtraLight.17ca5eb.ttf";